import axios from 'axios'
var source = null
const jobCodeService = {
  cancelApiRequest() {
    source.cancel('API request Cancelled')
  },
  checkVideoValidity(url) {
    const config = {
      timeout: 5000,
      validateStatus: status => {}
    }
    const instance = axios.create({
      responseType: 'blob'
    })
    return new Promise((resolve, reject) => {
      instance
        .get(url)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  uploadVid(context, data) {
    return new Promise((resolve, reject) => {
      source = axios.CancelToken.source()
      axios({
        method: 'POST',
        url: '/jobcode/upload',
        data: data.formData,
        cancelToken: source.token,
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          context.commit(
            'jobCodeModule/videoPercentage',
            {
              fileIndex: data.fileIndex,
              percentCompleted
            },
            {
              root: true
            }
          )
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  uploadWelcomeVid(context, data) {
    return new Promise((resolve, reject) => {
      source = axios.CancelToken.source()
      axios({
        method: 'POST',
        url: '/jobcode/onboarding/uploadvideo',
        data: data,
        cancelToken: source.token,
        onUploadProgress: function(progressEvent) {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          context.commit('jobCodeModule/uploadProgress', percentCompleted, { root: true })
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  uploadVideoAnswer(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/jobcode/upload/videoanswer?bookingId=${data.bookingId}&questionNo=${data.questionNo}`,
        data: data.formData,
        onUploadProgress: function(progressEvent) {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          context.commit(
            'jobCodeModule/recordingPercentage',
            { questionNo: data.questionNo, progress: percentCompleted },
            { root: true }
          )
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getUploadedInterviewAnswers(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/jobcode/uploadedvideos?bookingId=${data.bookingId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateVideoTrimming(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/jobcode/upload/videoanswer?bookingId=${data.bookingId}&questionNo=${data.questionNo}&trimDataOnly=true`,
        data: data.formData,
        onUploadProgress: function(progressEvent) {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          context.commit(
            'jobCodeModule/recordingPercentage',
            { questionNo: data.questionNo, progress: percentCompleted },
            { root: true }
          )
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  uploadProfileVideoAnswer(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `profile/candidate/upload/profilevideo?questionNo=${data.questionNo}&uploadLink=true`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateProfileVideoTrimming(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/profile/candidate/upload/profilevideo?questionNo=${data.questionNo}${data.isLastAnswer ? `&isLastAnswer=${data.isLastAnswer}` : ''}`,
        data: data.formData,
        onUploadProgress: function(progressEvent) {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          context.commit(
            'jobCodeModule/recordingPercentage',
            { questionNo: data.questionNo, progress: percentCompleted },
            { root: true }
          )
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateJobCode(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/jobcode/update',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  removeVid(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/jobcode/removevideo',
        data: data
      })
        .then(response => {
          context.commit(
            'jobCodeModule/videoPercentage',
            {
              fileIndex: data.fileIndex,
              percentCompleted: null
            },
            {
              root: true
            }
          )
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteWelcomeVid(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/jobcode/onboarding/removevideo',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getJobCodeByBookingId(context, data) {
    return new Promise((resolve, reject) => {
      if (typeof data === 'object') return
      axios({
        method: 'GET',
        url: '/jobcode/getbybookingid?bookingId=' + data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getJobCodeByJobcodeId(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/jobcode/findbyid?id=${data.jobcodeId}&noauth=true`
      })
        .then(response => {
          // const data = response.data
          // if (data.length && data[0].questions.length) {
          //   // we sort the questions here to avoid ordering issues in web recording
          //   data[0].questions.sort(compareValues('question_no', 'asc'))
          // }
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getJobCodeById(id, uniqueid) {
    const { VUE_APP_ROOT_API } = process.env
    let genLink = `${VUE_APP_ROOT_API}/v1/jobcode/findbyid?id=${id}${
      uniqueid ? `&uniqueid=${uniqueid}` : ``
    }&noauth=true`
    return new Promise((resolve, reject) => {
      fetch(genLink)
        .then(res => resolve(res.json()))
        .catch(err => reject(err))
    })
  },
  findJobCodeByBookingId(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/jobcode/findbybookingid?bookingId=' + data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getWebExChannels(compId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/jobcode/webex/roomlist?companyId=${compId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  createJobCode(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/jobcode/create',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteQuesJobCode(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/jobcode/deletequestion',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  publishJobCode(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/jobcode/publish',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  applyJob(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/jobcode/findbyid?jobad=1&bookingid=${data.bookingId}`,
        data: data
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  reusePreviousApplication(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/jobcode/reuse/application`,
        data: data
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  myAppliedList() {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/jobcode/candidate/scannedlist'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  inviteCandidatesToJobCode(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/jobcode/invite/candidate',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  saveInterviewTrackingOptin(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `jc/track/interview/ra/optin?bookingId=${data.bookingId}&candidateEmail=${data.candidateEmail}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  saveInterviewTracking(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: 'jc/track/interview/ra',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  grantOrDeclineRequestAttempt(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: 'jc/track/interview/ra/grant',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getInterviewTrackingDataByUniqueId(uniqueId, bookingId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `jc/track/interview/by/uniqueid?uniqueId=${uniqueId}&bookingId=${bookingId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getInterviewTrackingDataByIp(ip, bookingId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `jc/track/interview/by/ip?ipAddress=${ip}&bookingId=${bookingId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getInterviewTrackingDataByAny(bookingId, ip, email, uniqueid) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `jc/track/interview/by/any?bookingId=${bookingId}${ip ? `&ipAddress=${ip}` : ''}${
          email ? `&candidateEmail=${email}` : ''
        }${uniqueid ? `&uniqueId=${uniqueid}` : ''}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  ipInfo() {
    // https://www.ipify.org/
    return new Promise((resolve, reject) => {
      fetch('https://api.ipify.org?format=json')
        .then(res => res.json())
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  }
}
export default jobCodeService
